"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportTravelTimeWorkflowFeature = void 0;
const react_1 = __importDefault(require("react"));
const TAAErrorBoundary_1 = require("../../components/Shared/TAAErrorBoundary");
const contexts_1 = require("../../contexts");
const components_1 = require("../../components");
const logger_1 = require("../../logger");
const ReportTravelTimeWorkflowFeature = () => {
    const { associateInfo } = (0, contexts_1.useTaaConfigsContext)();
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.REPORT_TRAVEL_TIME_WORKFLOW_FEATURE.COUNT,
            latencyMetricName: logger_1.METRICS.REPORT_TRAVEL_TIME_WORKFLOW_FEATURE.LATENCY
        },
        isComponentLoaded: true
    });
    (0, logger_1.useLogAppLatencyCF)('AtoZReportTravelTimeWorkflow');
    return (react_1.default.createElement(TAAErrorBoundary_1.TAAErrorBoundary, null,
        react_1.default.createElement(components_1.UnscheduledWorkWorkflow, { associateInfo: associateInfo })));
};
exports.ReportTravelTimeWorkflowFeature = ReportTravelTimeWorkflowFeature;
